export enum QBuilderFormTypes {
    Title = 'title',
    Client = 'client',
    Vendor = 'vendor',
    Assessment = 'assessment',
    Template = 'template',
    DueDate = 'due_date',
}